import "./square_btn.css";

function SquareBtn({ text, onClick, type = "button", className = "", ...props }) {
    return (
        <button
            type={type}
            className={`square-btn ${className}`}
            onClick={onClick}
            {...props}
        >
            {text}
        </button>
    );
}

export default SquareBtn;
